/* User APIs pertaining to Events */
import { Observable } from 'rxjs';
import { BaseController } from '~client/controller/base-controller';
import { RefundOfferRequest } from '~client/model/refund-offer-request';
import { RefundOfferCheckoutResponse } from '~client/model/refund-offer-checkout-response';
import { RefundOfferTransaction } from '~client/model/refund-offer-transaction';

export class EventUserRefundController extends BaseController {
  /* Refunds the offers provided */
  public refund$(request: RefundOfferRequest): Observable<RefundOfferTransaction[]> {
    return this.post$('/event/refund', request);
  }

  public refund(request: RefundOfferRequest): Promise<RefundOfferTransaction[]> {
    return this.post('/event/refund', request);
  }

  /* Provides a list of all offers and inventory that can be refunded. */
  public refundCheckout$(eventId: string): Observable<RefundOfferCheckoutResponse> {
    return this.get$('/event/refund/checkout', { eventId });
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src332225586/src/modules/client/src/controller/event-user-refund-controller.ts